"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketsController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const tickets_service_1 = require("./tickets.service");
const service_ticket_entity_1 = require("./service-ticket.entity");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
const notifications_service_1 = require("../notifications/notifications.service");
const notification_log_entity_1 = require("../notifications/notification-log.entity");
let TicketsController = class TicketsController {
    constructor(ticketsService, notificationsService) {
        this.ticketsService = ticketsService;
        this.notificationsService = notificationsService;
    }
    frontendBase(frontendUrl) {
        return frontendUrl ?? process.env['FRONTEND_PUBLIC_URL'] ?? 'http://localhost:4200';
    }
    findAll(customerId, status) {
        return this.ticketsService.findAll(customerId ? parseInt(customerId, 10) : undefined, status);
    }
    findOne(id) {
        return this.ticketsService.findById(id);
    }
    create(body, user) {
        return this.ticketsService.create({ ...body, createdById: user.id });
    }
    /**
     * Workflow transition endpoint — the single action surface for all stage advances.
     * Body: { action: string, ...payload fields }
     */
    transition(id, body, user) {
        const { action, ...payload } = body;
        return this.ticketsService.transition(id, action, payload, user);
    }
    /**
     * Generate (or return existing) evidence upload link for a ticket, then
     * dispatch it to the customer via the selected channels (WhatsApp / SMS / Email).
     */
    async generateEvidenceLink(id, body, user) {
        const frontendBase = this.frontendBase(body.frontendUrl);
        const link = await this.ticketsService.generateEvidenceLink(id, frontendBase);
        const uploadUrl = `${frontendBase}/evidence/upload/${link.token}`;
        try {
            await this.ticketsService.transition(id, 'collect_evidence', {});
        }
        catch (_) {
            // Already past this stage — ignore
        }
        const selectedChannels = (body.channels ?? [])
            .map(ch => ch.toLowerCase())
            .filter((ch) => Object.values(notification_log_entity_1.NotificationChannel).includes(ch));
        let notifications = [];
        if (selectedChannels.length > 0) {
            const ticket = await this.ticketsService.findById(id);
            const customer = ticket.customer;
            const sendOpts = {
                channels: selectedChannels,
                to: {
                    phone: customer?.phone,
                    email: customer?.email ?? undefined,
                    name: customer?.name,
                    customerId: customer?.id,
                },
                template: notification_log_entity_1.NotificationTemplate.EVIDENCE_LINK_SENT,
                variables: {
                    customerName: customer?.name ?? 'Customer',
                    ticketNumber: ticket.ticketNumber,
                    uploadLink: uploadUrl,
                },
                referenceId: id,
                referenceType: 'ticket',
                sentById: user.id,
            };
            notifications = await this.notificationsService.send(sendOpts);
        }
        return {
            token: link.token,
            uploadUrl,
            expiresAt: link.expiresAt,
            files: link.files ?? [],
            notifications,
        };
    }
    /** Get current evidence files for a ticket */
    async getEvidence(id) {
        const link = await this.ticketsService.getEvidenceLink(id);
        const frontendBase = this.frontendBase();
        return {
            token: link?.token ?? null,
            uploadUrl: link ? `${frontendBase}/evidence/upload/${link.token}` : null,
            files: link?.files ?? [],
            uploadComplete: link?.uploadComplete ?? false,
            expiresAt: link?.expiresAt ?? null,
        };
    }
    /** Set logistics priority + comment after claim validated */
    setLogisticsPriority(id, body) {
        return this.ticketsService.setEvidencePriority(id, body.priority, body.comment);
    }
    updateStatus(id, body) {
        return this.ticketsService.updateStatus(id, body.status, body.remarks);
    }
    escalate(id, body) {
        if (body.teamLeadId) {
            return this.ticketsService.escalateToTeamLead(id, body.teamLeadId);
        }
        return this.ticketsService.escalateToManagement(id);
    }
    resolve(id, body, user) {
        return this.ticketsService.resolve(id, body.finalRemarks, user.id);
    }
};
exports.TicketsController = TicketsController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Query)('customerId')),
    tslib_1.__param(1, (0, common_1.Query)('status')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_c = typeof service_ticket_entity_1.TicketStatus !== "undefined" && service_ticket_entity_1.TicketStatus) === "function" ? _c : Object]),
    tslib_1.__metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], TicketsController.prototype, "findAll", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], TicketsController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_f = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], TicketsController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/transition'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_h = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _h : Object]),
    tslib_1.__metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
], TicketsController.prototype, "transition", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/evidence-link'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_k = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _k : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], TicketsController.prototype, "generateEvidenceLink", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id/evidence'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", Promise)
], TicketsController.prototype, "getEvidence", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/logistics-priority'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", void 0)
], TicketsController.prototype, "setLogisticsPriority", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/status'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_l = typeof Promise !== "undefined" && Promise) === "function" ? _l : Object)
], TicketsController.prototype, "updateStatus", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/escalate'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_ESCALATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
], TicketsController.prototype, "escalate", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/resolve'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.TICKETS_RESOLVE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_o = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _o : Object]),
    tslib_1.__metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
], TicketsController.prototype, "resolve", null);
exports.TicketsController = TicketsController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('tickets'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof tickets_service_1.TicketsService !== "undefined" && tickets_service_1.TicketsService) === "function" ? _a : Object, typeof (_b = typeof notifications_service_1.NotificationsService !== "undefined" && notifications_service_1.NotificationsService) === "function" ? _b : Object])
], TicketsController);
